<template>
  <div>
    <el-card :body-style="cardBodyStyle">

      <el-form :inline="true">
        <el-form-item style="margin-bottom: 0px;">
          <el-input v-model="queryUserDesc" placeholder="请输入查询条件" size="small"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0px;">
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
        <el-form-item style="margin-bottom: 0px;">
          <el-button type="primary" plain @click="handleAdd" size="small">新增</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card :body-style="cardBodyStyle">

      <el-table :data="tableData" border highlight-current-row @header-dragend="handleDragend">
        <el-table-column type="index" label="序号" align="center" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <!--      <el-table-column v-for="item in cols" :key="item.id" :prop="item.prop" :label="item.label" :width="item.width"
        show-overflow-tooltip :header-align="item.headerAlign" :align="item.align" :sortable="item.sortable=='true'"
        class-name="canDrag" :formatter="formatter">
      </el-table-column> -->
        <el-table-column prop="userCode" label="用户编码" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userDesc" label="姓名" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="memo" label="备注" width="140" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="addTime" label="添加日期" width="200" show-overflow-tooltip header-align="center"
          align="center">
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200px">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :page-size="pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" background layout="sizes, prev, pager, next" :total="totalRows">
      </el-pagination>
    </el-card>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="编辑" :visible.sync="dialogVisible" center width="80%">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form :model="user" label-width="80px" label-position="right">
            <el-form-item label="用户编码" v-if="false">
              <el-input v-model="user.id" size="small"></el-input>
            </el-form-item>
            <el-form-item label="用户编码">
              <el-input v-model="user.userCode" size="small"></el-input>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input v-model="user.userName" size="small"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名">
              <el-input v-model="user.userDesc" size="small"></el-input>
            </el-form-item>
            <el-form-item label="用户密码">
              <el-input v-model="user.password" size="small"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="user.idCard" size="small"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="user.phone" size="small"></el-input>
            </el-form-item>
            <el-form-item label="管理员">
              <el-radio-group v-model="user.adminFlag">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

        </el-col>
        <el-col :span="6">
          <el-input placeholder="角色名称或编码" v-model="queryRole" size="small">
            <el-button slot="append" icon="el-icon-search" @click="searchRole"></el-button>
          </el-input>
          <el-table :data="noRoleTableData" border highlight-current-row @row-click="noRoleRowClick">
            <el-table-column label="未选列表">
              <el-table-column prop="id" label="编号" v-if="isShow">
              </el-table-column>
              <el-table-column prop="roleCode" label="角色编码" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="roleName" label="用户名称" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination small @current-change="noRoleCurrentChange" :current-page="noRoleCurrentPage"
            :page-size="noRolePageSize" layout=" prev, pager, next" :total="noRoleTotalRows">
          </el-pagination>
          <el-row>
            <el-col :span="8" :offset="4">
              <i class="el-icon-arrow-down" @click="roleHandleSave" style="font-size: 50px;margin-right: 160px;"></i>
            </el-col>
            <el-col :span="8" :offset="4">
              <i class="el-icon-arrow-up" @click="roleHandleRemove" style="font-size: 50px;"></i>
            </el-col>
          </el-row>

          <el-table :data="yesRoleTableData" border highlight-current-row @row-click="yesRoleRowClick">
            <el-table-column label="已选列表">
              <el-table-column prop="id" label="编号" width="60" v-if="isShow">
              </el-table-column>
              <el-table-column prop="roleCode" label="角色编码" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="roleName" label="用户名称" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination small @current-change="yesRoleCurrentChange" :current-page="yesRoleCurrentPage"
            :page-size="yesRolePageSize" layout="  prev, pager, next" :total="yesRoleTotalRows">
          </el-pagination>
        </el-col>





        <el-col :span="6">
          <el-tree :data="dataTree" :props="defaultProps" node-key="id" :expand-on-click-node="true"
            :default-expanded-keys="expandedKeys" show-checkbox accordion ref='department' check-strictly
            >
          </el-tree>
        </el-col>


        <el-col :span="6"> 
          <el-input placeholder="岗位名称或编码" v-model="queryPost" size="small">
            <el-button slot="append" icon="el-icon-search" @click="searchPost"></el-button>
          </el-input> 

          <el-table :data="noPostTableData" border highlight-current-row @row-click="noPostRowClick">
            <el-table-column label="未选列表">
              <el-table-column prop="id" label="编号" v-if="isShow">
              </el-table-column>
              <el-table-column prop="postCode" label="岗位编码" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="postName" label="岗位名称" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination small @current-change="noPostCurrentChange" :current-page="noPostCurrentPage"
            :page-size="noPostPageSize" layout=" prev, pager, next" :total="noPostTotalRows">
          </el-pagination>
          <el-row>
            <el-col :span="8" :offset="4">
              <i class="el-icon-arrow-down" @click="postHandleSave" style="font-size: 50px;margin-right: 160px;"></i>
            </el-col>
            <el-col :span="8" :offset="4">
              <i class="el-icon-arrow-up" @click="postHandleRemove" style="font-size: 50px;"></i>
            </el-col>
          </el-row>

          <el-table :data="yesPostTableData" border highlight-current-row @row-click="yesPostRowClick">
            <el-table-column label="已选列表">
              <el-table-column prop="id" label="编号" width="60" v-if="isShow">
              </el-table-column>
              <el-table-column prop="postCode" label="岗位编码" width="120" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="postName" label="岗位名称" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination small @current-change="yesPostCurrentChange" :current-page="yesPostCurrentPage"
            :page-size="yesPostPageSize" layout="  prev, pager, next" :total="yesPostTotalRows">
          </el-pagination>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button size="small" type="success" @click="handleSave">保存</el-button>
        <el-button size="small" type="danger" @click="handleCancelSave">取消</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import axios from '@/axios';
  import style from '@/tools/style.js'
  export default {
    data() {
      return {
        cols: [],
        cardBodyStyle: style.card,
        //表格初始化参数
        tableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        //查询条件
        queryUserDesc: '',
        //录入框
        dialogVisible: false,
        user: {
          id: '',
          userName: '',
          password: '',
          userDesc: '',
          adminFlag: '0'
        },
        isShow: false,
        loading: true,




        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'deptName'
        },
        expandedKeys: [],
        checkedKeys: [],


        noPostTableData: [],
        noPostCurrentPage: 1,
        noPostTotalRows: 0,
        noPostPageSizes: [10, 20, 30, 40],
        noPostPageSize: 10,


        yesPostTableData: [],
        yesPostCurrentPage: 1,
        yesPostTotalRows: 0,
        yesPostPageSizes: [10, 20, 30, 40],
        yesPostPageSize: 10,




        noRoleTableData: [],
        noRoleCurrentPage: 1,
        noRoleTotalRows: 0,
        noRolePageSizes: [10, 20, 30, 40],
        noRolePageSize: 10,


        yesRoleTableData: [],
        yesRoleCurrentPage: 1,
        yesRoleTotalRows: 0,
        yesRolePageSizes: [10, 20, 30, 40],
        yesRolePageSize: 10,

        noPost: {},
        yesPost: {},
        noRole: {},
        yesRole: {},


        queryRole: '',
        queryPost: ''
      }
    },
    mounted() {
      this.getCols()
      this.getTableData()
      this.getDataTree()
    },
    methods: {
      getCols() {
        var url = 'framework/TablePersonal/queryByUserIdMenuId.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          tname: '用户'
        }
        axios.get(url, param).then(response => {
          var temp = [];
          for (var col of response.data.data) {
            if (col.showFlag == 'true') {
              temp.push(col)
            }
          }
          var newArray = temp.slice(0);
          this.cols = [];
          this.$nextTick(() => {
            this.cols = newArray;
          });
        });
      },
      handleDragend(newWidth, oldWidth, column, event) {
        var url = 'framework/TablePersonal/widthDragend.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          prop: column.property,
          width: newWidth,
          tname: '用户'
        }
        axios.post(url, param).then(response => {});
      },
      formatter(row, column, cellValue, index) {
        if (column.property == 'memo') {
          return row.userName + '-' + row.userDesc
        }
        return cellValue
      },

      getTableData() {
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            this.tableData = response.data.data.list
            this.totalRows = response.data.data.total
          } else {
            this.$message({
              type: 'error',
              message: '操作失败！' + response.data.msg,
            });
          }
          this.loading = false
        });
      },

      getDataTree() {
        var url = 'framework/SysDepartment/queryTree.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          if (this.dataTree.length == 1) {
            for (var node of this.dataTree) {
              this.expandedKeys.push(node.id)
            }
          }
        });
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      handleSave(row) {
        // var json = JSON.stringify(this.user)
        // var url = 'framework/SysUser/save.do'
        // var param = {
        //   json: json,
        // }


        this.checkedKeys = this.$refs.department.getCheckedKeys()
        console.log(this.checkedKeys)
        var url = 'framework/SysUser/saveAll.do'
        var param = {
          json: JSON.stringify(this.user),
          roles: JSON.stringify(this.yesRoleTableData),
          departments: JSON.stringify(this.checkedKeys),
          posts: JSON.stringify(this.yesPostTableData)
        }
        axios.post(url, param).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '保存成功!',
            });
            this.getTableData()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '保存失败' + response.data.msg,
            });
          }
        });
      },
      handleCancelSave(row) {
        this.dialogVisible = false
      },

      handleAdd() {
        // var url = 'framework/Common/queryPrimaryKey.do'
        // var param = {}
        // axios.get(url, param).then(response => {
        //   if (response.data.code == '0') {
        this.dialogVisible = true
        this.user = {
          id: '',
          userCode: '',
          userName: '',
          password: '',
          idCard: '',
          phone: '',
          adminFlag: '0'
        }
        var url = 'framework/SysUser/queryNewCode.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.user.userCode = response.data.data.code
        });

        this.getNoPostTableData()
        this.getYesPostTableData()
        this.getNoRoleTableData()
        this.getYesRoleTableData()


        // } else {
        //   this.$message({
        //     type: 'error',
        //     message: '查询失败' + response.data.msg
        //   });
        // }
        // });
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.user = row
        this.getUserDepartment()
        this.getNoPostTableData()
        this.getYesPostTableData()
        this.getNoRoleTableData()
        this.getYesRoleTableData()

      },
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          var url = 'framework/SysUser/remove.do'
          var param = {
            id: id
          }
          axios.post(url, param).then(response => {
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      search() {
        this.currentPage = 1
        this.getTableData()
      },

      checkChange(data, checked, indeterminate) {
        // var url = 'framework/SysUserDept/check.do'
        // var param = {
        //   userId: this.user.id,
        //   departmentId: data.id,
        //   checked: checked
        // }
        // axios.post(url, param).then(response => {
        //   if (response.data.code == 0) {

        //   } else {
        //     this.$message({
        //       type: 'error',
        //       message: '删除失败' + response.data.msg
        //     });
        //   }
        // });
      },

      getUserDepartment() {
        var url = 'framework/SysUserDept/queryByUserId.do'
        var param = {
          userId: this.user.id,
        }
        axios.get(url, param).then(response => {
          if (response.data.code == 0) {
            var arr = []
            for (var userdept of response.data.data) {
              arr.push(userdept.dept.id)
            }
            this.$refs.department.setCheckedKeys(arr)

          } else {
            this.$message({
              type: 'error',
              message: '失败' + response.data.msg
            });
          }
        });

      },









      searchRole() {
        console.log(this.queryRole)
        this.noRoleCurrentPage = 1
        this.getNoRoleTableData()
      },

      noRoleRowClick(row) {
        this.noRole = row
      },
      yesRoleRowClick(row) {
        this.yesRole = row
      },
      getNoRoleTableData() {
        var url = 'framework/SysRole/querySystemRolePage.do'
        var param = {
          page: this.noRoleCurrentPage,
          rows: this.noRolePageSize,
          userId: this.user.id,
          namecode: this.queryRole
        }
        axios.get(url, param).then(response => {
          this.noRoleTableData = response.data.data.list
          this.noRoleTotalRows = response.data.data.total
        });
      },
      getYesRoleTableData() {
        var url = 'framework/SysRole/queryUserRolePage.do'
        var param = {
          page: this.yesRoleCurrentPage,
          rows: this.yesRolePageSize,
          userId: this.user.id
        }
        axios.get(url, param).then(response => {
          this.yesRoleTableData = response.data.data.list
          this.yesRoleTotalRows = response.data.data.total
        });
      },

      noRoleCurrentChange(val) {
        this.noRoleCurrentPage = val
        this.getNoRoleTableData()
      },
      yesRoleCurrentChange(val) {
        this.yesRoleCurrentPage = val
        this.getYesRoleTableData()
      },



      roleHandleSave(row) {
        this.yesRoleTableData.push(this.noRole)
        this.noRoleTableData.forEach((item, index, arr) => {
          if (item.id === this.noRole.id) {
            this.noRoleTableData.splice(index, 1);
          }
        });
        // var url = 'framework/SysUserRole/save.do'
        // var param = {
        //   userId: this.user.id,
        //   roleId: this.noRole.id,
        // }
        // axios.post(url, param).then(response => {
        //   if (response.data.code == '0') {
        //     this.$message({
        //       type: 'success',
        //       message: '操作成功!',
        //     });
        //     this.getNoRoleTableData()
        //     this.getYesRoleTableData()
        //   } else {
        //     this.$message({
        //       type: 'error',
        //       message: '操作失败!' + response.data.msg
        //     });
        //   }
        // });
      },
      roleHandleRemove(row) {
        this.yesRoleTableData.forEach((item, index, arr) => {
          if (item.id === this.yesRole.id) {
            this.yesRoleTableData.splice(index, 1);
          }
        });
        this.noRoleTableData.push(this.yesRole)
        // var url = 'framework/SysUserRole/remove.do'
        // var param = {
        //   userId: this.user.id,
        //   roleId: this.yesRole.id,
        // }
        // axios.post(url, param).then(response => {
        //   if (response.data.code == '0') {
        //     this.$message({
        //       type: 'success',
        //       message: '操作成功!',
        //     });
        //     this.getNoRoleTableData()
        //     this.getYesRoleTableData()
        //   } else {
        //     this.$message({
        //       type: 'error',
        //       message: '操作失败!' + response.data.msg
        //     });
        //   }
        // });
      },
















      searchPost() {
        this.noRoleCurrentPage = 1
        this.getNoPostTableData()
      },
      noPostRowClick(row) {
        this.noPost = row
      },
      yesPostRowClick(row) {
        this.yesPost = row
      },
      getNoPostTableData() {
        var url = 'framework/SysPost/querySystemPostPage.do'
        var param = {
          page: this.noPostCurrentPage,
          rows: this.noPostPageSize,
          userId: this.user.id,
          namecode: this.queryPost
        }
        axios.get(url, param).then(response => {
          this.noPostTableData = response.data.data.list
          this.noPostTotalRows = response.data.data.total
        });
      },
      getYesPostTableData() {
        var url = 'framework/SysPost/queryUserPostPage.do'
        var param = {
          page: this.yesPostCurrentPage,
          rows: this.yesPostPageSize,
          userId: this.user.id
        }
        axios.get(url, param).then(response => {
          this.yesPostTableData = response.data.data.list
          this.yesPostTotalRows = response.data.data.total
        });
      },
      noPostCurrentChange(val) {
        this.noPostCurrentPage = val
        this.getNoPostTableData()
      },
      yesPostCurrentChange(val) {
        this.yesPostCurrentPage = val
        this.getYesPostTableData()
      },
      postHandleSave(row) {
        this.yesPostTableData.push(this.noPost)
        this.noPostTableData.forEach((item, index, arr) => {
          if (item.id === this.noPost.id) {
            this.noPostTableData.splice(index, 1);
          }
        });
        // var url = 'framework/SysUserPost/choose.do'
        // var param = {
        //   userId: this.user.id,
        //   postId: this.noPost.id,
        // }
        // axios.post(url, param).then(response => {
        //   if (response.data.code == '0') {
        //     this.$message({
        //       type: 'success',
        //       message: '操作成功!',
        //     });
        //     this.getNoPostTableData()
        //     this.getYesPostTableData()
        //   } else {
        //     this.$message({
        //       type: 'error',
        //       message: '操作失败!' + response.data.msg
        //     });
        //   }
        // });
      },
      postHandleRemove(row) {
        this.yesPostTableData.forEach((item, index, arr) => {
          if (item.id === this.yesPost.id) {
            this.yesPostTableData.splice(index, 1);
          }
        });
        this.noPostTableData.push(this.yesPost)

        // var url = 'framework/SysUserPost/unchoose.do'
        // var addId = sessionStorage.getItem('userId');
        // var param = {
        //   userId: this.user.id,
        //   postId: this.yesPost.id,
        // }
        // axios.post(url, param).then(response => {
        //   if (response.data.code == '0') {
        //     this.$message({
        //       type: 'success',
        //       message: '操作成功!',
        //     });
        //     this.getNoPostTableData()
        //     this.getYesPostTableData()
        //   } else {
        //     this.$message({
        //       type: 'error',
        //       message: '操作失败!' + response.data.msg
        //     });
        //   }
        // });
      },




    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/user.vue